import {trackEvent} from '@hconnect/common/logging/Analytics'
import {useUserContext} from '@hconnect/login'
import {getPlantName, useUpmPlantsContext} from '@hconnect/upm'
import {useCallback, useRef} from 'react'

import {useUrlParamOptional} from '@refra/modules/routing/hooks'

export const TrackingEvent = {
  onAddMaterialInstallation: 'onAddMaterialInstallation',
  onEditMaterialInstallation: 'onEditMaterialInstallation',
  onRemoveMaterialInstallation: 'onRemoveMaterialInstallation',
  onAddDrilling: 'onAddDrilling',
  onEditDrilling: 'onEditDrilling',
  onDeleteDrilling: 'onDeleteDrilling',
  onAddShutdown: 'onAddShutdown',
  onEditShutdown: 'onEditShutdown',
  onDeleteShutdown: 'onDeleteShutdown'
} as const

const PRODUCT_NAME = 'refraplanner' as const
type TrackingEventName = (typeof TrackingEvent)[keyof typeof TrackingEvent]

export interface RefraPlannerEvent {
  name: TrackingEventName
  [key: string]: string | number | boolean | undefined
}

interface TrackingContext {
  plantId: string | undefined
  plantName: string | undefined
  country: string | undefined
  userId: string | undefined
}

export const useTrackRefraPlannerEvent = () => {
  const plantId = useUrlParamOptional('plantCode')
  const {loggedUser} = useUserContext()
  const userId = loggedUser?.id
  const upmPlants = useUpmPlantsContext()

  const plantName = plantId ? getPlantName(upmPlants, plantId) : undefined
  const country = plantId ? upmPlants[plantId]?.country : undefined

  const contextRef = useRef<TrackingContext>({plantId, plantName, country, userId})
  contextRef.current = {plantId, plantName, country, userId}

  return useCallback(({name, ...eventData}: RefraPlannerEvent) => {
    const {plantId, plantName, country, userId} = contextRef.current

    trackEvent(name, {
      product: PRODUCT_NAME,
      plantId,
      plantName,
      country,
      userId,
      timestamp: new Date().toISOString(),
      ...eventData
    })
  }, [])
}
